import type { Language, SystemId } from "./types";

const strings = {
  en: {
    tagline: "Keep the last relay alive for three minutes.",
    begin: "BEGIN DIVE",
    audioOn: "AUDIO ON",
    audioOff: "AUDIO OFF",
    wave: "WAVE",
    hull: "HULL",
    shield: "SHIELD",
    power: "POWER",
    pulse: "PULSE",
    paused: "DIVE PAUSED",
    resume: "RESUME",
    restart: "RESTART",
    relayOnline: "RELAY ONLINE",
    mission1: "Contacts forming beyond the light.",
    mission2: "Stalkers incoming. Keep moving.",
    mission3: "The trench is waking up.",
    mission4: "Leviathan contact. Expose the core.",
    wonTitle: "SIGNAL HELD",
    wonSummary: "The leviathan is down. The relay survives.",
    lostTitle: "SIGNAL LOST",
    lostSummary: "The hull failed, but the trench remembers the run.",
    score: "SCORE",
    kills: "KILLS",
    diveAgain: "DIVE AGAIN",
    share: "SHARE RUN",
    copied: "Run report copied.",
    sonarReady: "SONAR READY",
    sonarCharging: "CHARGING",
    leviathan: "LEVIATHAN",
    chain: "CHAIN",
    bestChain: "BEST CHAIN",
    surge: "POWER SURGE",
    onboardingMove: "Move the submarine",
    onboardingPower: "Route one power unit",
    onboardingSonar: "Trigger sonar",
    systems: {
      propulsion: "THRUST",
      sonar: "SONAR",
      shield: "SHIELD",
      repair: "REPAIR",
      weapons: "WEAPONS",
    },
  },
  ko: {
    tagline: "3분 동안 마지막 심해 중계기를 지키세요.",
    begin: "잠수 시작",
    audioOn: "소리 켜짐",
    audioOff: "소리 꺼짐",
    wave: "웨이브",
    hull: "선체",
    shield: "방어막",
    power: "전력",
    pulse: "소나",
    paused: "잠수 일시정지",
    resume: "계속",
    restart: "재시작",
    relayOnline: "중계기 연결",
    mission1: "빛 너머에서 접촉 신호가 형성됩니다.",
    mission2: "추적자가 접근합니다. 계속 이동하세요.",
    mission3: "해구가 깨어나고 있습니다.",
    mission4: "레비아탄 접촉. 핵을 노출시키세요.",
    wonTitle: "신호 유지",
    wonSummary: "레비아탄을 쓰러뜨렸습니다. 중계기가 살아남았습니다.",
    lostTitle: "신호 소실",
    lostSummary: "선체는 무너졌지만 해구는 이번 기록을 기억합니다.",
    score: "점수",
    kills: "격파",
    diveAgain: "다시 잠수",
    share: "기록 공유",
    copied: "플레이 기록을 복사했습니다.",
    sonarReady: "소나 준비",
    sonarCharging: "충전 중",
    leviathan: "레비아탄",
    chain: "연쇄",
    bestChain: "최고 연쇄",
    surge: "파워 서지",
    onboardingMove: "잠수함을 이동하세요",
    onboardingPower: "전력 한 칸을 배분하세요",
    onboardingSonar: "소나를 발동하세요",
    systems: {
      propulsion: "추진",
      sonar: "소나",
      shield: "방어",
      repair: "수리",
      weapons: "무장",
    },
  },
} as const;

type WidenStrings<T> = {
  -readonly [Key in keyof T]: T[Key] extends string ? string : WidenStrings<T[Key]>;
};

export type Translation = WidenStrings<(typeof strings)["en"]>;

export function translation(language: Language): Translation {
  return strings[language];
}

export function systemLabel(language: Language, system: SystemId): string {
  return strings[language].systems[system];
}
